module.exports = __webpack_public_path__ + "icons/original/large/large-a4.30bcbdd3b26849030d9f7756c19d6a98.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/large/large-a4.png
// module id = ytF8
// module chunks = app